export default "__VITE_ASSET__DQoJ933x__"